module.exports = __webpack_public_path__ + "img/40_69_003_400.32e8bbda.jpg";